import { servicePayments } from "../servicePayments";

export const deleteEngagement = async (id: string): Promise<void> => {
  const response = await servicePayments.delete(`/engagement/${id}`);
  return response.data;
};
